export const environment = {
  production: false,
  API_DOMAINS: {
    LOGIN: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/auth',
    USERS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/users',
    MAWB: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/awb',
    AWB_HEADER: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/awb/header',
    MASTER_FLIGHTS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/flights',
    TRUCK_TRAVEL: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/truck/travel',
    TRUCKS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/truck/travel/trucks',
    COMPANY: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/truck/travel/companies',
    TYPE_TRAVEL: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/truck/travel/type',
    FLIGHTS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/flights',
    MAWB_DETAIL: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/mawb',
    AWB_ROUTE: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/awb/detail/route',
    FLOW: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/flow',
    STATUS_CODES: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/status-code',
    KEY_WORDS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/key-word',
    EXTERNAL: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/external',
    RECEIVED_MESSAGES: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/received-messages',
    COUNTRY: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/country',
    NEWS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/news',
    ITINERARY: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/itinerary',
    PRE_ALERT: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/pre/alert',
    GOVERNMENT_ADDRESS: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/government-address',
    STATUS_CODE_COMPANY: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/status-code-company',
    PRE_ALERT_EXCEL_UPLOAD: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/pre-alert',
    SUNAT: 'https://api.serhafen-staging.andinolabs.tech/customs-legacy/sunat',
    ENV: 'STAGE',
  },

  GLOBAL_SETTINGS: {
    MESSAGE_LOADING_INFORMATION: 'Cargando información, por favor espere un momento ...',
    MESSAGE_PROCESSING_INFORMATION: 'Procesando información, por favor espere un momento ...',
    GENERATING_DOCUMENT: 'Generando documento, por favor espere un momento ...',
  },
  TYPE: 'pc',
  CONSTANTS :{
    QUERY_HAWBS_BY_TRACKING_ID : true,
    AUTO_REFRESH_DATA_GRID_TOGGLE : true,
    AUTO_REFRESH_SUMMARY_PANNEL_TOGGLE :true,
    INVOICE_WORD_TOGGLE: true,
    IS_BATCH_FILE_TAB_DISABLE: true,
  }
};
